import { IconProps } from './types';

export function Indeterminate({ size, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line x1="3.5" y1="15.25" x2="26.5" y2="15.25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
